// extracted by mini-css-extract-plugin
export default {"paymentFields":"CheckoutForm-module_paymentFields__Vx8n6","cvc":"CheckoutForm-module_cvc__p0xD0","postalCode":"CheckoutForm-module_postalCode__XfUm3"};